export default __webpack_public_path__ + "77c2057da640449464df546f37448419.svg";